package com.shadowings.gero.presentation.ui


import androidx.compose.material3.Typography
import androidx.compose.runtime.Composable
import androidx.compose.ui.text.font.FontFamily
import com.shadowings.gero.presentation.util.DeviceClass
import com.shadowings.gero.presentation.util.DeviceInfo
import gero.composeapp.generated.resources.NotoSans_Regular
import gero.composeapp.generated.resources.NotoSansEgyptianHieroglyphs_Regular
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.Roboto_Condensed_Medium
import org.jetbrains.compose.resources.ExperimentalResourceApi
import org.jetbrains.compose.resources.Font

@OptIn(ExperimentalResourceApi::class)
@Composable
fun bodyFontFamily() = FontFamily(
    Font(Res.font.NotoSans_Regular)
)

@OptIn(ExperimentalResourceApi::class)
@Composable
fun displayFontFamily() = FontFamily(
    Font(Res.font.Roboto_Condensed_Medium)
)

@OptIn(ExperimentalResourceApi::class)
@Composable
fun titleFontFamily() = FontFamily(
    Font(Res.font.NotoSansEgyptianHieroglyphs_Regular)
)


// Default Material 3 typography values
val baseline = Typography()

@Composable
fun appTypography(deviceInfo: DeviceInfo): Typography {
    val multiplier = when (deviceInfo.deviceClass) {
        DeviceClass.PHONE_SMALL -> 0.8f
        DeviceClass.PHONE_MEDIUM -> 0.9f
        DeviceClass.PHONE_LARGE -> 1f
        DeviceClass.TABLET_MEDIUM -> 1.1f
        DeviceClass.TABLET_LARGE -> 1.2f
        DeviceClass.WEB_FULL -> 1.2f
    }
    return Typography(
        displayLarge = baseline.displayLarge.copy(
            fontFamily = displayFontFamily(),
            fontSize = baseline.displayLarge.fontSize * multiplier,
            lineHeight = baseline.displayLarge.lineHeight * multiplier
        ),
        displayMedium = baseline.displayMedium.copy(
            fontFamily = displayFontFamily(),
            fontSize = baseline.displayMedium.fontSize * multiplier,
            lineHeight = baseline.displayMedium.lineHeight * multiplier
        ),
        displaySmall = baseline.displaySmall.copy(
            fontFamily = displayFontFamily(),
            fontSize = baseline.displaySmall.fontSize * multiplier,
            lineHeight = baseline.displaySmall.lineHeight * multiplier
        ),
        headlineLarge = baseline.headlineLarge.copy(
            fontFamily = displayFontFamily(),
            fontSize = baseline.headlineLarge.fontSize * multiplier,
            lineHeight = baseline.headlineLarge.lineHeight * multiplier
        ),
        headlineMedium = baseline.headlineMedium.copy(
            fontFamily = displayFontFamily(),
            fontSize = baseline.headlineMedium.fontSize * multiplier,
            lineHeight = baseline.headlineMedium.lineHeight * multiplier
        ),
        headlineSmall = baseline.headlineSmall.copy(
            fontFamily = displayFontFamily(),
            fontSize = baseline.headlineSmall.fontSize * multiplier,
            lineHeight = baseline.headlineSmall.lineHeight * multiplier
        ),
        titleLarge = baseline.titleLarge.copy(
            fontFamily = displayFontFamily(),
            fontSize = baseline.titleLarge.fontSize * multiplier,
            lineHeight = baseline.titleLarge.lineHeight * multiplier
        ),
        titleMedium = baseline.titleMedium.copy(
            fontFamily = displayFontFamily(),
            fontSize = baseline.titleMedium.fontSize * multiplier,
            lineHeight = baseline.titleMedium.lineHeight * multiplier
        ),
        titleSmall = baseline.titleSmall.copy(
            fontFamily = displayFontFamily(),
            fontSize = baseline.titleSmall.fontSize * multiplier,
            lineHeight = baseline.titleSmall.lineHeight * multiplier
        ),
        bodyLarge = baseline.bodyLarge.copy(
            fontFamily = bodyFontFamily(),
            fontSize = baseline.bodyLarge.fontSize * multiplier,
            lineHeight = baseline.bodyLarge.lineHeight * multiplier
        ),
        bodyMedium = baseline.bodyMedium.copy(
            fontFamily = bodyFontFamily(),
            fontSize = baseline.bodyMedium.fontSize * multiplier,
            lineHeight = baseline.bodyMedium.lineHeight * multiplier
        ),
        bodySmall = baseline.bodySmall.copy(
            fontFamily = bodyFontFamily(),
            fontSize = baseline.bodySmall.fontSize * multiplier,
            lineHeight = baseline.bodySmall.lineHeight * multiplier
        ),
        labelLarge = baseline.labelLarge.copy(
            fontFamily = bodyFontFamily(),
            fontSize = baseline.labelLarge.fontSize * multiplier,
            lineHeight = baseline.labelLarge.lineHeight * multiplier
        ),
        labelMedium = baseline.labelMedium.copy(
            fontFamily = bodyFontFamily(),
            fontSize = baseline.labelMedium.fontSize * multiplier,
            lineHeight = baseline.labelMedium.lineHeight * multiplier
        ),
        labelSmall = baseline.labelSmall.copy(
            fontFamily = bodyFontFamily(),
            fontSize = baseline.labelSmall.fontSize * multiplier,
            lineHeight = baseline.labelSmall.lineHeight * multiplier
        )
    )
}


